import listActions from 'src/modules/wellnessCheck/list/wellnessCheckListActions';
import WellnessCheckService from 'src/modules/wellnessCheck/wellnessCheckService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'AFFIRMATION_PROGRAM_UNARCHIVE';

const wellnessCheckUnarchiveActions = {
  UNARCHIVE_STARTED: `${prefix}_UNARCHIVE_STARTED`,
  UNARCHIVE_SUCCESS: `${prefix}_UNARCHIVE_SUCCESS`,
  UNARCHIVE_ERROR: `${prefix}_UNARCHIVE_ERROR`,

  UNARCHIVE_ALL_STARTED: `${prefix}_UNARCHIVE_ALL_STARTED`,
  UNARCHIVE_ALL_SUCCESS: `${prefix}_UNARCHIVE_ALL_SUCCESS`,
  UNARCHIVE_ALL_ERROR: `${prefix}_UNARCHIVE_ALL_ERROR`,

  doUnarchive: (id) => async (dispatch) => {
    try {
      dispatch({
        type: wellnessCheckUnarchiveActions.UNARCHIVE_STARTED,
      });

      await WellnessCheckService.unarchiveAll([id]);

      dispatch({
        type: wellnessCheckUnarchiveActions.UNARCHIVE_SUCCESS,
      });

      Message.success(
        i18n('entities.wellnessCheck.unarchive.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/wellness-check');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: wellnessCheckUnarchiveActions.UNARCHIVE_ERROR,
      });
    }
  },

  doUnarchiveAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: wellnessCheckUnarchiveActions.UNARCHIVE_ALL_STARTED,
      });

      await WellnessCheckService.unarchiveAll(ids);

      dispatch({
        type: wellnessCheckUnarchiveActions.UNARCHIVE_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.wellnessCheck.unarchiveAll.success'),
      );

      getHistory().push('/wellness-check');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: wellnessCheckUnarchiveActions.UNARCHIVE_ALL_ERROR,
      });
    }
  },
};

export default wellnessCheckUnarchiveActions;
